// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"bO-z","carouselContainer":"cO-z"};